/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LabelsConfig,
    LabelsConfigFromJSON,
    LabelsConfigFromJSONTyped,
    LabelsConfigToJSON,
    SkipConfig,
    SkipConfigFromJSON,
    SkipConfigFromJSONTyped,
    SkipConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutomaticTriageConfig
 */
export interface AutomaticTriageConfig {
    /**
     * 
     * @type {string}
     * @memberof AutomaticTriageConfig
     */
    label?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AutomaticTriageConfig
     */
    removeAssignees?: boolean;
    /**
     * 
     * @type {LabelsConfig}
     * @memberof AutomaticTriageConfig
     */
    labels?: LabelsConfig;
    /**
     * 
     * @type {SkipConfig}
     * @memberof AutomaticTriageConfig
     */
    skip?: SkipConfig;
}

export function AutomaticTriageConfigFromJSON(json: any): AutomaticTriageConfig {
    return AutomaticTriageConfigFromJSONTyped(json, false);
}

export function AutomaticTriageConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomaticTriageConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'removeAssignees': !exists(json, 'removeAssignees') ? undefined : json['removeAssignees'],
        'labels': !exists(json, 'labels') ? undefined : LabelsConfigFromJSON(json['labels']),
        'skip': !exists(json, 'skip') ? undefined : SkipConfigFromJSON(json['skip']),
    };
}

export function AutomaticTriageConfigToJSON(value?: AutomaticTriageConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'removeAssignees': value.removeAssignees,
        'labels': LabelsConfigToJSON(value.labels),
        'skip': SkipConfigToJSON(value.skip),
    };
}

